import { BeneficiaryEntityType, PaymentMethods } from 'types/beneficiaries'

export const DEFAULT_FIAT_INSTRUMENT = {
  sourceWalletLsid: '',
  // Basic beneficiary details
  transferDestination: '',
  paymentMethods: [],
  entityType: BeneficiaryEntityType.BUSINESS,
  description: '',
  currency: '',
  isSelfOwned: false,
  beneficiaryAddressLine1: '',
  beneficiaryAddressLine2: '',
  beneficiaryCity: '',
  beneficiaryRegion: '',
  beneficiaryPostCode: '',
  beneficiaryCountryCode: '',
  // Bank account details
  accountNumber: '',
  bankCode: '',
  accountType: '',
  paymentMethod: '',
  bankName: '',
  bankAddressLine1: '',
  bankAddressLine2: '',
  bankCity: '',
  bankRegion: '',
  bankPostCode: '',
  bankCountryCode: '',
  // Intermediary bank details
  intermediaryBankCode: '',
  intermediaryBankSwiftCode: '',
  intermediaryBankName: '',
  intermediaryBankAddressLine1: '',
  intermediaryBankAddressLine2: '',
  intermediaryBankCity: '',
  intermediaryBankRegion: '',
  intermediaryBankPostCode: '',
  intermediaryBankCountryCode: '',
}

// Address fields
export const MIN_LENGTH = 2
export const MAX_LENGTH = 200
export const ADDRESS_LINE_MAX_LENGTH = 35
export const ADDRESS_FIELDS_REQUIRED_TOGETHER = ['addressLine1', 'city', 'postCode', 'region']

export const CURRENCY_RESET_FIELDS = [
  'description',
  'accountNumber',
  'accountNumberConfirm',
  'bankCode',
  'accountType',
  'bankName',
  'bankAddressLine1',
  'bankAddressLine2',
  'bankCity',
  'bankRegion',
  'bankPostCode',
  'bankCountryCode',
  'bankCountryName',
  'bankNameCode',
  'intermediaryBankCode',
  'intermediaryBankSwiftCode',
  'intermediaryBankName',
  'intermediaryBankAddressLine1',
  'intermediaryBankAddressLine2',
  'intermediaryBankCity',
  'intermediaryBankRegion',
  'intermediaryBankPostCode',
  'intermediaryBankCountryCode',
  'transferDestination',
  'sameAsContactAddress',
  'beneficiaryAddressLine1',
  'beneficiaryAddressLine2',
  'beneficiaryCity',
  'beneficiaryPostCode',
  'beneficiaryRegion',
  'beneficiaryCountryCode',
  'sameAccountHolderNameAsContact',
  'sameAsContactAddress',
] as const

export const TRANSFER_DESTINATION_RESET_FIELDS = ['currency', ...CURRENCY_RESET_FIELDS] as const

export const MIN_NAME_LENGTH = 3
export const MAX_NAME_LENGTH = 150

export const PAYMENT_METHODS_LABELS = {
  [PaymentMethods.SWIFT]: 'paymentMethodsLabels.swift',
  [PaymentMethods.SEPA]: 'paymentMethodsLabels.sepa',
  [PaymentMethods.SEPA_INSTANT]: 'paymentMethodsLabels.sepaInstant',
  [PaymentMethods.FASTER_PAYMENT]: 'paymentMethodsLabels.fasterPayment',
  [PaymentMethods.CHAPS]: 'paymentMethodsLabels.chaps',
  [PaymentMethods.BACS]: 'paymentMethodsLabels.bacs',
  [PaymentMethods.CCC_PAYMENTS]: 'paymentMethodsLabels.cccPayments',
  [PaymentMethods.ACH]: 'paymentMethodsLabels.ach',
  [PaymentMethods.ACH_SAME_DAY]: 'paymentMethodsLabels.achSameDay',
  [PaymentMethods.FEDWIRE]: 'paymentMethodsLabels.fedwire',
  [PaymentMethods.FEDNOW]: 'paymentMethodsLabels.fednow',
  [PaymentMethods.CRNOW]: 'paymentMethodsLabels.crnow',
  [PaymentMethods.RTP]: 'paymentMethodsLabels.rtp',
} as const

export const IBAN_VALIDATION_ERRORS = {
  COUNTRY_DOES_NOT_SUPPORT_IBAN: 'Country does not support IBAN standard',
} as const
